<template>
	<div class="form-actions mb-3">
	  <div class="text-right">
      <router-link v-if="mode!='add' && mode!='edit' && mode!='authorize' && mode!='decline' && mode!='userstatusupdate' && mode!='changepassword'" class="btn btn-primary btn-flat " tag='a' :to="{ path: '/'+url.add}"><i class="fas fa-plus"></i> Add </router-link>
      <router-link v-if="mode=='add' || mode =='edit' || mode=='authorize' || mode=='decline' || mode=='userstatusupdate' && mode=='changepassword'" class="btn btn-info btn-flat " tag='a' :to="{ path: '/'+url.init}"><i class="fas fa-list"></i> List </router-link>
      </div>
	</div>
</template>
<script>
  export default {
    name: 'mode-button',
    props: ['url', 'mode']
  }
</script> 